/**
 * Shared "recently viewed" store for the wellbeing hub.
 *
 * The hub records a visit when a card is clicked, but members also reach
 * topics directly (deep link, journal link, search), so topic pages call
 * `recordWellbeingVisit` on mount. Both paths write the same key.
 */
export const WELLBEING_RECENT_KEY = "wb-recent";
export const WELLBEING_RECENT_MAX = 4;

export function readWellbeingRecents(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(WELLBEING_RECENT_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((s): s is string => typeof s === "string")
      : [];
  } catch {
    return [];
  }
}

export function recordWellbeingVisit(slug: string): string[] {
  if (typeof window === "undefined") return [];
  const next = [slug, ...readWellbeingRecents().filter((s) => s !== slug)].slice(
    0,
    WELLBEING_RECENT_MAX,
  );
  try {
    window.localStorage.setItem(WELLBEING_RECENT_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}
